import { useQuery } from '@tanstack/react-query'

import { useAuthenticatedUser } from '../../../auth/hooks/useAuthenticatedUser'
import {
  fetchHerplanGeblokkeerdeWeken,
  initialState,
} from '../services/fetchHerplanGeblokkeerdeWeken'

export { useHerplanGeblokkeerdeWeken, queryKey }

const queryKey = 'herplan-geblokkeerde-weken'

const useHerplanGeblokkeerdeWeken = ({
  gebiedscodes,
  organisatie,
}: {
  gebiedscodes: string[]
  organisatie: string
}) => {
  const { hasPermissions } = useAuthenticatedUser()

  const { data } = useQuery({
    queryFn: () => fetchHerplanGeblokkeerdeWeken({ gebiedscodes, organisatie }),
    queryKey: [queryKey, gebiedscodes, organisatie],
    enabled:
      hasPermissions &&
      !!organisatie &&
      !!gebiedscodes.length &&
      gebiedscodes.some((code) => code !== ''),
  })

  return {
    data: data || initialState.data,
  }
}
